import { deflate, inflate } from 'pako';

import { InitialData, migrate } from 'src/reducers/migrations/migrate';
import { Project } from 'src/store/state/projects';
import { createProjectExportState } from 'src/utils/exportProject/createProjectExportState';
import {
  uint8ArrayToUrl,
  urlToUint8Array,
} from 'src/utils/exportProject/urlConversion';

export const encodeProject = (
  project: Project,
  version: number
): string | null => {
  try {
    const state = createProjectExportState(project, version);
    const uncompressed = JSON.stringify(state);
    const u8 = deflate(uncompressed);
    const url = uint8ArrayToUrl(u8);

    return url;
  } catch (err) {
    console.error('error in encodeProject:', err);
    return null;
  }
};

export const decodeProject = (encoded: string) => {
  try {
    const u8 = urlToUint8Array(encoded);
    const uncompressed = inflate(u8, { to: 'string' });
    const result = JSON.parse(uncompressed || '{}');

    // also need to validate data + version here...
    const isValid = result?.state?.projects && result?.version;
    if (!isValid) {
      throw new Error('Project is invalid.');
    }

    const { state, version } = result as InitialData;
    // using migrate() here means that the "version" is not the current app version,
    // but the app version of the latest migration
    return migrate(state, version);
  } catch (err) {
    console.error(err);
    throw err;
  }
};
